export const CLR_TOOLTIP_ARROW_HEIGHT = 11;
export const CLR_TOOLTIP_GAP = 4;

export function getClrTooltipAnchor(props) {
  const anchor = props?.activeCoordinate ?? props?.coordinate;
  if (!anchor || anchor.x == null || anchor.y == null) {
    return null;
  }
  return anchor;
}

export function clrTooltipPosition(props) {
  const anchor = getClrTooltipAnchor(props);
  if (!anchor) return props?.coordinate;

  return {
    x: anchor.x,
    y: anchor.y,
  };
}

export const CLR_TOOLTIP_PROPS = {
  position: clrTooltipPosition,
  offset: 0,
  isAnimationActive: false,
  allowEscapeViewBox: { x: true, y: true },
  wrapperStyle: {
    pointerEvents: 'none',
    outline: 'none',
    zIndex: 30,
  },
};
